import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import type { CountrySelectItem } from '@/constant/phone';
const phoneUtil = PhoneNumberUtil.getInstance();

export const allowOnlyNumbers = (e: Event) => {
  const input = e.target as HTMLInputElement;
  input.value = input.value.replaceAll(/\D+/g, '');
};

/**
 * Un numéro complet est mis au format E.164 : le 0 national saisi par habitude
 * est retiré (`+33` + `0689438684` -> `+33689438684`).
 * Un numéro incomplet ou invalide est renvoyé tel quel (le validateur le signalera).
 */
export function formatToInternationalPhoneFormat(input: string, prefix: string): string {
  const digits = input.replace(/\D/g, '');
  if (!digits) return '';

  const phone = prefix + digits;
  try {
    const parsed = phoneUtil.parse(phone);
    return phoneUtil.isValidNumber(parsed) ? phoneUtil.format(parsed, PhoneNumberFormat.E164) : phone;
  } catch {
    return phone;
  }
}

export function formatFrenchPhone(internationalNumber: string): string {
  try {
    const parsed = phoneUtil.parse(internationalNumber);
    return phoneUtil.format(parsed, PhoneNumberFormat.NATIONAL);
  } catch {
    return internationalNumber;
  }
}

export function extractCountryFromPhone(
  internationalNumber: string,
  countries: CountrySelectItem[],
): CountrySelectItem | undefined {
  return countries
    .filter((c) => internationalNumber.startsWith(c.prefix))
    .reduce<
      CountrySelectItem | undefined
    >((best, c) => (!best || c.prefix.length > best.prefix.length ? c : best), undefined);
}
